// imports shared across all ORA templates
require('../ora/base/imports');

// modules
require('../ora/modules/small-content-intro-read-more');
require('../ora/modules/comparison-card-slider');
require('../ora/modules/toggle-comparison-table');
require('../ora/modules/force-table-width');
require('../ora/modules/shake-comparison-cards');

// ORA home page styles
require('../../styles/entry/ora-comparison.less')
